import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OwlDateTimeComponent } from '@danielmoncada/angular-datetime-picker';

interface TimeSlot {
  fromTime: any;
  toTime: any;
}

interface DaySchedule {
  day: string;
  timeSlot: TimeSlot; // Changed from timeSlots array to single timeSlot
}

@Component({
  selector: 'app-custom-schedule',
  templateUrl: './custom-schedule.component.html',
  styleUrls: ['./custom-schedule.component.scss']
})
export class CustomScheduleComponent {
  days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  scheduledDays: DaySchedule[] = [];
  deletedDays: string[] = [];

  @ViewChild('dateTimePicker') dateTimePicker: OwlDateTimeComponent<Date>;

  constructor(
    public dialogRef: MatDialogRef<CustomScheduleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { availability: any[] }
  ) {
    this.initializeFromData();
    if (this.scheduledDays.length === 0) {
      this.addNewDay();
    }
  }
convertToDateTimeObject(timeString: string): Date | null {
  if (!timeString) return null;
  
  const [hours, minutes] = timeString.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
}
  initializeFromData() {
    if (this.data.availability) {
      this.scheduledDays = this.data.availability
        .filter(item => item.TimeSlots && item.TimeSlots.length === 1 && item.isCustomSchedule)
        .map(item => ({
          day: item.Day,
          timeSlot: {
            fromTime: this.convertToDateTimeObject(item.TimeSlots[0].From),
            toTime: this.convertToDateTimeObject(item.TimeSlots[0].To)
          }
        }));
    }
  }

  addNewDay() {
    if (this.scheduledDays.length < this.days.length) {
      this.scheduledDays.push({
        day: '',
        timeSlot: { fromTime: '', toTime: '' }
      });
    }
  }

  removeDay(dayIndex: number) {
  const removedDay = this.scheduledDays[dayIndex];
  this.scheduledDays.splice(dayIndex, 1);

  // deletedDays me store kar lo
  this.deletedDays.push(removedDay.day);
}

  getAvailableDays(currentDay: string): string[] {
    return this.days.filter(day => 
      !this.scheduledDays.some(d => d.day === day) || day === currentDay
    );
  }
parseTimeFromInput(timeString: string): string {
  if (!timeString) return '';
  const date = new Date(timeString);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}
 applySchedule() {
  const result = [];

  // 1. Scheduled days
  this.scheduledDays.forEach(day => {
    if (day.day && day.timeSlot.fromTime && day.timeSlot.toTime) {
      result.push({
        day: day.day,
        timeSlot: {
          From: this.parseTimeFromInput(day.timeSlot.fromTime),
          To: this.parseTimeFromInput(day.timeSlot.toTime)
        }
      });
    }
  });

  // 2. Deleted days
  this.deletedDays.forEach(dayName => {
    result.push({
      day: dayName,
      timeSlot: { From: '', To: '' }
    });
  });

  this.dialogRef.close(result);
}



}